module.exports = __webpack_public_path__ + "img/docAppointRes_a.d5b0bf3d.png";